import Enum from "@rover/types/src/Enum";
export default class FooterTheme extends Enum<string> {
  static LIGHT = new FooterTheme('light');
  static DARK = new FooterTheme('dark');
  static isLocked = true;
}